import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';

import * as CatalogueModels from '../../models/catalogue/catalogue';
import { CatalogueSearchModel } from '../../models/catalogue/catalogueSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import { TyrePreviewModel } from '../../models/tyre/tyrePreview';

@Injectable({
  providedIn: 'root'
})

export class CatalogueService {

constructor(private httpClient: HttpClient,
            private environment: EnvironmentService
            ) {}


public getList(Search: CatalogueSearchModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  Search.RequestSignature = Math.random();

  const options = {headers: httpHeaders};
  return this.httpClient.post<CatalogueModels.CatalogueListModel>(`${this.environment.getApiURL()}/catalogue/list`, Search, options);
}

public get(CatalogueId: number) {
  return this.httpClient.get<CatalogueModels.CatalogueObjectModel>(`${this.environment.getApiURL()}/catalogue/get/${CatalogueId}`);
}


public delete(TyreId: number) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};

  return this.httpClient.get<HttpEventType>(`${this.environment.getApiURL()}/catalogue/delete/${TyreId}`,  options);
}

public insertNew(NewTyre: CatalogueModels.NewTyreModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};
  return this.httpClient.post<TyrePreviewModel>(
    `${this.environment.getApiURL()}/catalogue/insert`, NewTyre , options);
}

public set(Tyre: CatalogueModels.NewTyreModel) {
  const httpHeaders = new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('Cache-Control', 'no-cache');

  const options = {headers: httpHeaders};

  return this.httpClient.post<CatalogueModels.CatalogueModel>(`${this.environment.getApiURL()}/catalogue/set`, Tyre, options);
}

}
